import { UTILITY_APPS, flushUtilityApps } from './utilityAppStorage';
import axiosInstance from '../store/api';
import { resolvePremiumPrice } from './premiumPricing';
import { API_URL } from './constants';
import {
  LEGACY_KARDEX_KEY,
  LEGACY_MIGRATED_KEY,
} from '../components/inventario/services/migrateLegacyData';

const API_URL_CONFIG = API_URL + '/config';
// cloudStorage / backend
// cloudStorage / backend (frontend config)
export const APPS = {
  personal_finance_v1: {title: 'Finanzas personales', description: 'Registra ingresos y gastos, aprende a presupuestar y comprende tu patrimonio. Gratis · Reportes financieros incluidos sin suscripción.', link: '/apps/personal-finances', premium: false, normalPrice: 0, storageKey: null, transactional: true, categoria: 'Utilitarios'},
  devssoft_forms_v1: {title: 'Devssoft Forms', description: 'Crea encuestas con Google, condiciones, gráficos automáticos y exportación Excel.', link: '/apps/forms', premium: false, normalPrice: 0, billingPeriod: 'month', storageKey: null, transactional: true, categoria: 'Utilitarios'},
  projectbase_pm_v1: {
    title: 'ProjectBase PM',
    description: 'Planifica proyectos, cursos y talleres; gestiona recursos, ejecución y resultados con MCP.',
    link: '/apps/projectbase', premium: false, normalPrice: 0, storageKey: null, transactional: true, categoria: 'CoreBase'
  },
  corebase_crm_v1: {
    title: 'CoreBase CRM',
    includedSellers: 3,
    additionalSellerPrice: 1,
    additionalSellerAnnualPrice: 10,
    description: 'CRM para negocios de servicios. Gestiona leads, ventas y seguimiento comercial.',
    link: '/apps/corebase',
    premium: false,
    normalPrice: 0,
    storageKey: 'corebase_crm_v1',
    categoria: 'CoreBase'
  },
  inventario: {
    title: 'Inventario',
    description: 'Controla tu stock y su valor.',
    link: '/apps/inventario',
    price: 8,
    premium: true,
    storageKey: 'kardex_v1',
    categoria: 'CoreBase'
  },
  retail_pos_v1: {
    title: 'POS Retail Ropa',
    description: 'Sistema de inventario y punto de venta para tiendas de ropa con código de barras.',
    link: '/apps/retail-pos',
    price: 3,
    premium: true,
    storageKey: 'retail_pos_v1',
    categoria: 'CoreBase'
  },
  devssoft_chat_v1: {
    hidden: true,
    title: 'DevsSoft Chat',
    description: 'Consulta y analiza tus negocios con IA. Inventario y POS Retail (solo lectura).',
    link: '/apps/devssoft-chat',
    price: 8,
    premium: true,
    storageKey: 'devssoft_chat_v1',
    categoria: 'CoreBase'
  },
  fastfood_pos_v1: {
    title: 'POS Comida Rápida',
    description: 'Controla ventas, imprime tickets y analiza qué platos se venden más.',
    link: '/apps/fastfood',
    premium: true,
    price: 2,
    storageKey: null, transactional: true,
    categoria: 'CoreBase'
  },
  loan_calculator: {
    title: 'Calculadora de Préstamos',
    description: 'Simula tus préstamos y calcula cuotas.',
    link: '/apps/loan-calculator',
    premium: false,
    storageKey: 'loanCalculatorData',
    categoria: 'Utilitarios'
  },
  cv_builder: {
    title: 'Constructor de Currículum',
    description: 'Crea y guarda tus currículums gratis.',
    link: '/apps/cv-builder',
    premium: false,
    storageKey: null,
    transactional: true,
    categoria: 'Utilitarios'
  },
  growth_planner: {
    title: 'Growth Planner',
    description: 'Planifica rutas profesionales, mide progreso y construye CVs por objetivo.',
    link: '/apps/growth-planner',
    premium: false,
    storageKey: null, transactional: true,
    categoria: 'Utilitarios'
  },
  fitness: {
    title: 'Fitness',
    description: 'Registra y controla tus rutinas de ejercicio.',
    link: '/apps/fitness',
    premium: false,
    storageKey: null, transactional: true,
    categoria: 'Utilitarios'
  },
  libro_compras: {
    title: 'Libro de Compras',
    description: 'Registra y controla las compras de tu negocio.',
    link: '/apps/compras',
    premium: false,
    storageKey: null, transactional: true,
    categoria: 'Utilitarios'
  },
  libro_ventas: {
    title: 'Libro de Ventas',
    description: 'Controla tus ventas diarias.',
    link: '/apps/ventas',
    premium: false,
    storageKey: null, transactional: true,
    categoria: 'Utilitarios'
  },
  libro_gastos: {
    title: 'Libro de Gastos',
    description: 'Registra los gastos operativos.',
    link: '/apps/gastos',
    premium: false,
    storageKey: null, transactional: true,
    categoria: 'Utilitarios'
  },
  punto_equilibrio: {
    title: 'Punto de Equilibrio',
    description: 'Calcula cuántas unidades necesitas vender.',
    link: '/apps/punto-equilibrio',
    premium: false,
    storageKey: null,
    transactional: true,
    categoria: 'Utilitarios'
  },
  citas: {
    title: 'Citas y Reservas',
    description: 'Gestiona tu agenda y reservas.',
    link: '/apps/citas',
    premium: false,
    storageKey: 'citasData',
    categoria: 'Utilitarios'
  }
};
// Keep existing price consumers compatible while resolving expiring offers at read time.
Object.values(APPS).forEach(app => {
  app.currency = 'USD';
  const normalPrice = app.normalPrice ?? app.price;
  if (app.premium) {
    app.normalPrice = normalPrice;
    Object.defineProperty(app, 'price', { enumerable: true, get: () => resolvePremiumPrice({ normalPrice, promotionalPrice: app.promotionalPrice, promotionEndsAt: app.promotionEndsAt }).basePrice });
  }
});
export const cloudSync = {
  pull: async () => {
    try {
      const { data } = await axiosInstance.get(API_URL_CONFIG);

      Object.entries(data).forEach(([key, value]) => {
        if (['cvDataStorage', 'breakEvenV2', ...Object.values(UTILITY_APPS)].includes(key)) return;
        if (key === LEGACY_KARDEX_KEY && localStorage.getItem(LEGACY_MIGRATED_KEY) === 'done') {
          return;
        }

        localStorage.setItem(
          key,
          typeof value === 'object' ? JSON.stringify(value) : value
        );
      });

      console.log('☁️ Datos sincronizados desde la nube');
      window.dispatchEvent(new Event('cloud-sync-complete'));
    } catch (e) {
      console.error('Error en Pull Sync', e);
    }
  },

  pushAll: async () => {
    let utilityFailure;
    try { await flushUtilityApps(); } catch (error) { utilityFailure = error; }
    try {
      const payload = {};

      Object.values(APPS).forEach(app => {
  app.currency = 'USD';
        const key = app.storageKey;
        if (!key) return;
        if (key === LEGACY_KARDEX_KEY && localStorage.getItem(LEGACY_MIGRATED_KEY) === 'done') return;

        const item = localStorage.getItem(key);
        if (!item) return;

        try {
          payload[key] = JSON.parse(item);
        } catch {
          payload[key] = item;
        }
      });

      if (Object.keys(payload).length === 0) return;

      await axiosInstance.post(API_URL_CONFIG, payload);
      console.log('🚀 Respaldo en la nube completado');
    } catch (e) {
      console.error('Error al sincronizar con MongoDB', e);
    } finally {
      // A conflict in another app must not prevent legacy backups (including
      // Retail's compatibility key). Still report that not every app synced.
      if (utilityFailure) throw utilityFailure;
    }
  }
};
